import { render, staticRenderFns } from "./IframeOverlay.vue?vue&type=template&id=3d1ef29f&scoped=true"
import script from "./IframeOverlay.vue?vue&type=script&lang=js"
export * from "./IframeOverlay.vue?vue&type=script&lang=js"
import style0 from "./IframeOverlay.vue?vue&type=style&index=0&id=3d1ef29f&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d1ef29f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Projekte\\Filati\\filatiapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d1ef29f')) {
      api.createRecord('3d1ef29f', component.options)
    } else {
      api.reload('3d1ef29f', component.options)
    }
    module.hot.accept("./IframeOverlay.vue?vue&type=template&id=3d1ef29f&scoped=true", function () {
      api.rerender('3d1ef29f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/goodpay/IframeOverlay.vue"
export default component.exports